<div class="flex items-center justify-start gap-6">
  <!-- User -->
  <div class="flex flex-col gap-1.5 text-end leading-none">
    <span class="font-medium">Mario Rossi</span>
    <span class="text-sm">{{ user.email }}</span>
  </div>

  <!-- Menu -->
  <button mat-icon-button (click)="signOut()">
    <mat-icon
      [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
    ></mat-icon>
  </button>
</div>
